import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Config from "./Config/index.json";
import "./Public/css/reactCss.css";
import "./Public/css/responsive.css";
import "./Public/css/style.css";
import AppRouter from "./Router/AppRouter";

// http://192.168.1.191:5000/
// http://142.116.32.110:5000/
// http://rma-dev-api.techwens.com

//get the host  and port from the url
let URL;
if (window.location.hostname === "localhost") {
  URL = `${Config.LocalURL}/api`;
} else {
  URL = `${Config.ServerURL}/api`;
}
axios.defaults.baseURL = URL;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;

function App() {
  return (
    <div className="App">
      <AppRouter />
      <ToastContainer limit={1} />
    </div>
  );
}

export default App;
